"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.McuType = void 0;
var McuType;
(function (McuType) {
    McuType[McuType["Other"] = 0] = "Other";
    McuType[McuType["ESP8266"] = 1] = "ESP8266";
    McuType[McuType["ESP32"] = 2] = "ESP32";
    McuType[McuType["OWOTRACK_ANDROID"] = 3] = "OWOTRACK_ANDROID";
    McuType[McuType["WRANGLER"] = 4] = "WRANGLER";
    McuType[McuType["OWOTRACK_IOS"] = 5] = "OWOTRACK_IOS";
    McuType[McuType["ESP32_C3"] = 6] = "ESP32_C3";
    McuType[McuType["MOCOPI"] = 7] = "MOCOPI";
    McuType[McuType["HARITORA"] = 8] = "HARITORA";
    McuType[McuType["DEV_RESERVED"] = 250] = "DEV_RESERVED";
})(McuType = exports.McuType || (exports.McuType = {}));
